import React, { useState, useEffect } from 'react';
import { Box, Typography, Link, CircularProgress } from '@material-ui/core';
import { authAxios } from '../../services/serviceUtils';

// FIXLATER
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function PointOfSale() {
  const [token, setToken] = useState<{ status: string; authlink: string }>();
  const [status, setStatus] = useState<{ posinfo: any[]; status: string }>();

  useEffect(() => {
    authAxios
      .get<{ status: string; authlink: string }>('/pos/sqr-get-token')
      .then((res) => {
        console.log(res);
        setToken(res.data);
      });

    authAxios
      .get<{ posinfo: any[]; status: string }>('/pos/pos-status')
      .then((res) => {
        console.log(res);
        setStatus(res.data);
      });
  }, []);

  return (
    <Box maxWidth="lg" style={{ marginTop: '40px' }}>
      <Typography component="h3" variant="h4" gutterBottom>
        Point of Sale
      </Typography>
      <div>
        {status ? (
          status.posinfo.length > 0 ? (
            <Typography>Point of Sale approved with Square.</Typography>
          ) : (
            <Typography>
              Authorize <Link href={token?.authlink}>Square</Link>.
            </Typography>
          )
        ) : (
          <CircularProgress />
        )}
      </div>
    </Box>
  );
}

export default PointOfSale;
